import { EVOLUCION_DENUNCIAS_CHART } from '../../../common/constants/charts'

const normalizeText = (value = '') =>
  value
    .normalize('NFD')
    .replace(/[\u0300-\u036f]/g, '')
    .toLowerCase()
    .replace(/\*/g, '')
    .replace(/\s+/g, ' ')
    .trim()

const shouldRemoveDonutHint = (chartId, text) => {
  const normalized = normalizeText(text)
  if (!normalized) return false

  if (chartId === 'tipo-accidente') {
    return (
      normalized.includes('tipo de accidente') ||
      normalized.includes('tipo de gravedad') ||
      normalized.includes('grafico de dona de tipo de accidente') ||
      normalized.includes('grafico de dona de tipo de gravedad') ||
      normalized.includes('no incluye los siniestros rechazados') ||
      normalized.includes('cantidades unitarias y porcentuales')
    )
  }

  if (chartId === 'tipo-gravedad') {
    return (
      normalized.includes('tipo de accidente') ||
      normalized.includes('tipo de gravedad') ||
      normalized.includes('grafico de dona de tipo de accidente') ||
      normalized.includes('grafico de dona de tipo de gravedad') ||
      normalized.includes('no incluye los siniestros rechazados ni covid') ||
      normalized.includes('cantidades unitarias y porcentuales')
    )
  }

  return false
}

const fetchBase64 = (url) =>
  fetch(url)
    .then((r) => r.blob())
    .then(
      (blob) =>
        new Promise((resolve) => {
          const reader = new FileReader()
          reader.onloadend = () => resolve(reader.result)
          reader.readAsDataURL(blob)
        })
    )
    .catch(() => '')

const captureChartPng = (chartId) =>
  new Promise((resolve) => {
    const wrapper = document.querySelector(`[data-chart-id="${chartId}"]`)
    if (!wrapper) {
      resolve('')
      return
    }

    const svgEl = wrapper.querySelector('svg')
    if (!svgEl) {
      resolve('')
      return
    }

    const w = svgEl.clientWidth || svgEl.viewBox?.baseVal?.width || 800
    const h = svgEl.clientHeight || svgEl.viewBox?.baseVal?.height || 456

    const clone = svgEl.cloneNode(true)
    clone.setAttribute('xmlns', 'http://www.w3.org/2000/svg')
    clone.setAttribute('width', w)
    clone.setAttribute('height', h)

    if (chartId === 'evolucion-denuncias') {
      clone.querySelectorAll('text').forEach((textEl) => {
        if (textEl.textContent.trim().toLowerCase() === EVOLUCION_DENUNCIAS_CHART.title.toLowerCase()) textEl.remove()
      })
    }

    if (chartId === 'tipo-accidente' || chartId === 'tipo-gravedad') {
      clone.querySelectorAll('text').forEach((textEl) => {
        if (shouldRemoveDonutHint(chartId, textEl.textContent || '')) {
          textEl.remove()
        }
      })
    }

    const svgString = new XMLSerializer().serializeToString(clone)
    const blob = new Blob([svgString], { type: 'image/svg+xml;charset=utf-8' })
    const url = URL.createObjectURL(blob)
    const img = new Image()

    img.onload = () => {
      const scale = 2
      const canvas = document.createElement('canvas')
      canvas.width = w * scale
      canvas.height = h * scale
      const ctx = canvas.getContext('2d')
      ctx.fillStyle = '#ffffff'
      ctx.fillRect(0, 0, canvas.width, canvas.height)
      ctx.drawImage(img, 0, 0, canvas.width, canvas.height)
      URL.revokeObjectURL(url)
      resolve(canvas.toDataURL('image/png'))
    }
    img.onerror = () => {
      URL.revokeObjectURL(url)
      resolve('')
    }
    img.src = url
  })

export const captureInformeAssets = async (shouldRenderEvolucion) => {
  const [tipoAccidentePng, tipoGravedadPng, evolucionDenunciasPng, firma] = await Promise.all([
    captureChartPng('tipo-accidente'),
    captureChartPng('tipo-gravedad'),
    captureChartPng('evolucion-denuncias'),
    fetchBase64('/assets/Firma_gHerrmann.bmp'),
  ])

  return {
    tipoAccidentePng,
    tipoGravedadPng,
    evolucionDenunciasPng: shouldRenderEvolucion ? evolucionDenunciasPng : '',
    firma,
  }
}
